
export default function initNavArchiveActu(): void {
    const $navArchiveActu = document.querySelectorAll<HTMLElement>('.nav-custom');
    $navArchiveActu.forEach($container => {
        new NavArchiveActu($container);
    });
}

class NavArchiveActu {
    $el: HTMLElement | null | undefined;
    $searchBar: HTMLElement | null | undefined;
    $extraButton: HTMLButtonElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$searchBar = this.$el?.querySelector('.actu-archive-search');
        this.$extraButton = this.$el?.querySelector('.js-extra-nav-button');
        this.init();
    }

    init(): void {
        this.displayNavBar();

        if (this.$searchBar) {
            this.displayMobileSearchBar();
        }

        if (this.$extraButton) {
            this.displayExtraNav();
        }

    }

    displayNavBar(): void {
        const horizontalScrollHandler = (): void => {
            const $navLinks = this.$el?.querySelector('.js-nav-links') as HTMLElement;
            if ($navLinks.offsetWidth < ($navLinks.scrollWidth)) {
                $navLinks.classList.add('is-overflow');

                let isDown = false;
                let startX: number;
                let scrollLeft: number;

                $navLinks.addEventListener('mousedown', (e) => {
                    isDown = true;
                    startX = e.pageX - $navLinks.offsetLeft;
                    scrollLeft = $navLinks.scrollLeft;
                });
                $navLinks.addEventListener('mouseleave', () => {
                    isDown = false;
                });
                $navLinks.addEventListener('mouseup', () => {
                    isDown = false;
                });
                $navLinks.addEventListener('mousemove', (e) => {
                    if (!isDown) return;
                    e.preventDefault();
                    const x = e.pageX - $navLinks.offsetLeft;
                    const walk = (x - startX) * 1;
                    $navLinks.scrollLeft = scrollLeft - walk;
                });

            } else {
                $navLinks.classList.remove('is-overflow');
                const extraLinks = this.$el?.querySelector('.js-extra-links-wrapper--overflow');
                extraLinks?.classList.remove('extra-links-wrapper--active');
                this.$extraButton?.classList.remove('extra-nav-button--active');
            }
        }
        window.addEventListener('resize', () => horizontalScrollHandler());
        window.addEventListener('DOMContentLoaded', () => horizontalScrollHandler());
    }

    displayMobileSearchBar(): void {
        const navPos = this.$el?.getBoundingClientRect().top;

        if (navPos) {
            document.addEventListener('scroll', () => {
                if (navPos < window.scrollY) {
                    this.$searchBar?.classList.remove('actu-archive-search--hidden');
                } else {
                    this.$searchBar?.classList.add('actu-archive-search--hidden');
                }
            })
        }
    }

    displayExtraNav(): void {
        
        
        this.$extraButton?.addEventListener('click', () => {
            const overflow = this.$el?.querySelector('.is-overflow');
            if (overflow) {
                const extraLinks = this.$el?.querySelector('.js-extra-links-wrapper--overflow');

                extraLinks?.classList.toggle('extra-links-wrapper--active');
                this.$extraButton?.classList.toggle('extra-nav-button--active');
            } else {
                const extraLinks = this.$el?.querySelector('.js-extra-links-wrapper');

                extraLinks?.classList.toggle('extra-links-wrapper--active');
                this.$extraButton?.classList.toggle('extra-nav-button--active');
            }

        })
    }
}
